// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SuggestionCard-cls1__a5b4a952aeffa2031da3{/*!*/}.SuggestionCard-cls2___5af608b8217928ad24d{margin-top:auto;text-align:center}.SuggestionCard-cls2___5af608b8217928ad24d:not(:disabled){border:1px solid #9bb5e0}.SuggestionCard-cls2___5af608b8217928ad24d:not(:disabled):hover{border:1px solid #9bb5e0}.SuggestionCard-cls2___5af608b8217928ad24d>span{width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "SuggestionCard-cls1__a5b4a952aeffa2031da3",
	"cls2": "SuggestionCard-cls2___5af608b8217928ad24d SuggestionCard-cls1__a5b4a952aeffa2031da3"
};
export default ___CSS_LOADER_EXPORT___;
